/**
 * Пакет файлов: чистые правила состояния списка — без React и без сети.
 *
 * Элемент: { id, file, name, duration, status, taskId, error, done, byChannels }.
 * status: queued → uploading → processing → done | failed.
 * Обрыв одного файла не трогает остальные (макет: «Повторить · минуты не
 * списаны» у упавшей загрузки).
 */

let seq = 0;

export function packItems(files) {
  return Array.from(files || []).map((file) => ({
    id: `${Date.now()}-${seq += 1}`,
    file,
    name: file.name,
    duration: null,
    status: 'queued',
    taskId: null,
    error: null,
    done: null,
    byChannels: false,
  }));
}

export function updateItem(items, id, patch) {
  return items.map((it) => (it.id === id ? { ...it, ...patch } : it));
}

export function removeItem(items, id) {
  return items.filter((it) => it.id !== id);
}

/** «Пакет · 4 файла · 2 из 4 готово» — строка для шапки и боковой панели. */
export function packSummary(items) {
  const total = items.length;
  const done = items.filter((it) => it.status === 'done').length;
  const failed = items.filter((it) => it.status === 'failed').length;
  const filesWord = total === 1 ? 'файл' : (total >= 2 && total <= 4 ? 'файла' : 'файлов');
  const parts = [`Пакет · ${total} ${filesWord}`];
  if (done || failed) parts.push(`${done} из ${total} готово${failed ? `, ${failed} с ошибкой` : ''}`);
  return parts.join(' · ');
}

export function packFinished(items) {
  return items.length > 0 && items.every((it) => it.status === 'done' || it.status === 'failed');
}

export function packRunning(items) {
  return items.some((it) => it.status === 'uploading' || it.status === 'processing');
}

export const STATUS_LABEL = {
  queued: 'В очереди',
  uploading: 'Загрузка',
  processing: 'Распознаём',
  done: 'Готово',
  failed: 'Не получилось',
};
